var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 42,
    viewBox: "0 0 36 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53465 21.1438C9.53465 20.3013 10.2333 19.6027 11.0758 19.6027H22.3366V2.21837C22.3161 1.23203 21.5352 0.451172 20.5489 0.451172C8.44556 0.451172 0 8.89674 0 21C0 33.1032 8.44556 41.5488 20.5489 41.5488C21.5147 41.5488 22.3161 40.7679 22.3161 39.7816V22.6644H11.0758C10.2128 22.685 9.53465 21.9863 9.53465 21.1438Z",
    fill: "#FF6B35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5537 20.0554L29.7179 14.1989C29.122 13.603 28.1356 13.603 27.5397 14.1989C26.9438 14.7948 26.9438 15.7811 27.5397 16.3771L30.7453 19.5828H22.3203V22.6651H30.7248L27.5192 25.8707C26.9232 26.4666 26.9232 27.453 27.5192 28.0489C27.8274 28.3571 28.2178 28.5009 28.6083 28.5009C28.9987 28.5009 29.3891 28.3571 29.6973 28.0489L35.5332 22.1925C36.1497 21.6171 36.1497 20.6513 35.5537 20.0554Z",
    fill: "#FF6B35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5537 20.0554L29.7179 14.1989C29.122 13.603 28.1356 13.603 27.5397 14.1989C26.9438 14.7948 26.9438 15.7811 27.5397 16.3771L30.7453 19.5828H22.3203V22.6651H30.7248L27.5192 25.8707C26.9232 26.4666 26.9232 27.453 27.5192 28.0489C27.8274 28.3571 28.2178 28.5009 28.6083 28.5009C28.9987 28.5009 29.3891 28.3571 29.6973 28.0489L35.5332 22.1925C36.1497 21.6171 36.1497 20.6513 35.5537 20.0554Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogoutIcon);
export default __webpack_public_path__ + "static/media/profile-logout-icon.c66d1d882bd5ecda036929e09c33499c.svg";
export { ForwardRef as ReactComponent };